// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Vs-z","tooltipWrapper":"Ws-z","icon":"Xs-z","tooltip":"Ys-z","content":"Zs-z"};